(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-home-field"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    const closeBtn = e.target.closest('.search-home__close');
    if (!closeBtn) return;

    const wrapper = closeBtn.closest('predictive-search');
    if (!wrapper) return;

    const input = wrapper.querySelector('input[type="search"]');
    const results = wrapper.querySelector('[data-predictive-search]');

    if (input) input.value = '';
    if (results) results.innerHTML = '';

    wrapper.removeAttribute('open');
  });
  } catch(e) { console.error(e); }
})();

})();
